(() => {
  'use strict';

  const MOBILE_QUERY = window.matchMedia('(max-width: 999px)');
  let activePanel = null;
  let chatBusy = false;

  const getNav = () => document.querySelector('[data-mobile-bottom-navigation]');
  const getAppButton = (action) => document.querySelector(`[data-mobile-app-action="${action}"]`);
  const getMenuButtons = () => Array.from(document.querySelectorAll('[data-mobile-menu-action]'));
  const getMobileMenu = () => document.getElementById('mobile-menu');
  const menuIsOpen = () => getMobileMenu()?.getAttribute('aria-hidden') === 'false';

  const getHeaderMenuButton = () => {
    const buttons = Array.from(document.querySelectorAll('.header__mobile-nav-toggle[data-action="toggle-menu"]'));
    return buttons.find((button) => {
      const rect = button.getBoundingClientRect();
      const style = window.getComputedStyle(button);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }) || buttons[0] || null;
  };

  const setActiveButton = (action) => {
    document.querySelectorAll('.mobile-bottom-nav__item').forEach((button) => {
      if (button.matches('[data-mobile-app-action], [data-mobile-menu-action]')) button.classList.remove('is-active');
    });
    if (action === 'menu') getMenuButtons().forEach((button) => button.classList.add('is-active'));
    else if (action) getAppButton(action)?.classList.add('is-active');
  };

  const updateNavHeight = () => {
    const nav = getNav();
    if (!nav) return;
    const height = Math.ceil(nav.getBoundingClientRect().height || 64);
    document.documentElement.style.setProperty('--mobile-bottom-nav-rendered-height', `${height}px`);
  };

  const findSmileLauncher = () => {
    const container = document.querySelector('#smile-ui-container');
    if (!container) return null;
    const candidates = Array.from(container.querySelectorAll('button, [role="button"], a'));
    return candidates.find((element) => {
      const text = `${element.getAttribute('aria-label') || ''} ${element.textContent || ''}`.toLowerCase();
      return text.includes('reward') || text.includes('smile') || text.includes('launcher');
    }) || candidates[0] || null;
  };

  const SUPPORT_PANEL_ID = 'mobile-support-panel';
  const SUPPORT_BACKDROP_ID = 'mobile-support-backdrop';

  const getSupportPanel = () => document.getElementById(SUPPORT_PANEL_ID);
  const getSupportBackdrop = () => document.getElementById(SUPPORT_BACKDROP_ID);
  const supportIsOpen = () => getSupportPanel()?.getAttribute('aria-hidden') === 'false';

  const installSupportPanelStyles = () => {
    if (document.getElementById('mobile-support-panel-styles')) return;

    const style = document.createElement('style');
    style.id = 'mobile-support-panel-styles';
    style.textContent = `
      @media (max-width: 999px) {
        .mobile-support-backdrop {
          position: fixed;
          inset: 0;
          z-index: 2147482996;
          border: 0;
          padding: 0;
          background: rgba(0, 0, 0, .28);
        }

        .mobile-support-backdrop[hidden] {
          display: none !important;
        }

        .mobile-support-panel {
          position: fixed;
          right: 10px;
          bottom: calc(var(--mobile-bottom-nav-rendered-height, 64px) + 8px);
          z-index: 2147482998;
          width: min(var(--mobile-bottom-nav-panel-width, 400px), calc(100vw - 20px));
          height: min(var(--mobile-bottom-nav-chat-height, 560px), calc(100dvh - var(--mobile-bottom-nav-rendered-height, 64px) - 20px));
          max-height: calc(100dvh - var(--mobile-bottom-nav-rendered-height, 64px) - 20px);
          display: flex;
          flex-direction: column;
          overflow: hidden;
          border-radius: 16px;
          background: #fff;
          box-shadow: 0 10px 40px rgba(0, 0, 0, .24);
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transform: translateY(14px) scale(.985);
          transform-origin: bottom right;
          transition: opacity .18s ease, transform .18s ease, visibility 0s linear .18s;
        }

        .mobile-support-panel[aria-hidden="false"] {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
          transform: translateY(0) scale(1);
          transition-delay: 0s;
        }

        .mobile-support-panel__header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 16px;
          padding: 20px;
          color: #fff;
          background: #000;
        }

        .mobile-support-panel__title {
          margin: 0;
          font-size: 22px;
          line-height: 1.2;
          color: inherit;
        }

        .mobile-support-panel__status {
          display: flex;
          align-items: center;
          gap: 7px;
          margin: 7px 0 0;
          font-size: 13px;
          color: rgba(255, 255, 255, .82);
        }

        .mobile-support-panel__status-dot {
          width: 8px;
          height: 8px;
          flex: 0 0 auto;
          border-radius: 50%;
          background: #41c96b;
        }

        .mobile-support-panel__close {
          width: 38px;
          height: 38px;
          display: grid;
          place-items: center;
          flex: 0 0 auto;
          border: 0;
          border-radius: 50%;
          color: #fff;
          background: rgba(255, 255, 255, .12);
          cursor: pointer;
        }

        .mobile-support-panel__body {
          flex: 1 1 auto;
          min-height: 0;
          overflow-y: auto;
          padding: 18px;
          background: #f7f7f7;
          -webkit-overflow-scrolling: touch;
        }

        .mobile-support-panel__message {
          display: grid;
          gap: 5px;
          margin-bottom: 16px;
          padding: 15px;
          border-radius: 14px 14px 14px 4px;
          color: #fff;
          background: #000;
          font-size: 14px;
          line-height: 1.45;
        }

        .mobile-support-panel__form {
          display: grid;
          gap: 13px;
        }

        .mobile-support-panel__field {
          display: grid;
          gap: 6px;
          font-size: 13px;
          font-weight: 600;
          color: #222;
        }

        .mobile-support-panel__field small {
          font-weight: 400;
          color: #777;
        }

        .mobile-support-panel__field input,
        .mobile-support-panel__field textarea {
          width: 100%;
          min-height: 46px;
          margin: 0;
          padding: 11px 12px;
          border: 1px solid #d8d8d8;
          border-radius: 10px;
          outline: 0;
          color: #111;
          background: #fff;
          font: inherit;
          font-weight: 400;
          box-sizing: border-box;
        }

        .mobile-support-panel__field textarea {
          min-height: 110px;
          resize: vertical;
        }

        .mobile-support-panel__field input:focus,
        .mobile-support-panel__field textarea:focus {
          border-color: #111;
          box-shadow: 0 0 0 1px #111;
        }

        .mobile-support-panel__submit,
        .mobile-support-panel__track {
          min-height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 11px 16px;
          border-radius: 999px;
          font-size: 15px;
          font-weight: 700;
          text-align: center;
          text-decoration: none;
          cursor: pointer;
        }

        .mobile-support-panel__submit {
          border: 1px solid #000;
          color: #fff;
          background: #000;
        }

        .mobile-support-panel__track {
          border: 1px solid #cfcfcf;
          color: #111;
          background: #fff;
        }

        .mobile-support-panel__divider {
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 4px 0;
          color: #888;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: .08em;
        }

        .mobile-support-panel__divider::before,
        .mobile-support-panel__divider::after {
          content: "";
          height: 1px;
          flex: 1 1 auto;
          background: #ddd;
        }

        .mobile-support-panel__success,
        .mobile-support-panel__error {
          display: none;
          margin: 0 0 14px;
          padding: 12px 14px;
          border-radius: 10px;
          font-size: 14px;
          line-height: 1.4;
        }

        .mobile-support-panel__success {
          color: #0b5b2b;
          background: #e7f7ed;
        }

        .mobile-support-panel__error {
          color: #8c1f1f;
          background: #fdeaea;
        }

        .mobile-support-panel.is-success .mobile-support-panel__success,
        .mobile-support-panel.is-error .mobile-support-panel__error {
          display: block;
        }

        inbox-online-store-chat {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const createSupportPanel = () => {
    if (getSupportPanel()) return getSupportPanel();

    installSupportPanelStyles();

    const backdrop = document.createElement('button');
    backdrop.id = SUPPORT_BACKDROP_ID;
    backdrop.type = 'button';
    backdrop.className = 'mobile-support-backdrop';
    backdrop.setAttribute('aria-label', 'Close support');
    backdrop.hidden = true;

    const panel = document.createElement('section');
    panel.id = SUPPORT_PANEL_ID;
    panel.className = 'mobile-support-panel';
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('aria-label', 'Customer support');

    panel.innerHTML = `
      <div class="mobile-support-panel__header">
        <div>
          <h2 class="mobile-support-panel__title">Chat with us</h2>
          <p class="mobile-support-panel__status">
            <span class="mobile-support-panel__status-dot" aria-hidden="true"></span>
            Send us a message
          </p>
        </div>

        <button type="button" class="mobile-support-panel__close" data-mobile-support-close aria-label="Close support">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="mobile-support-panel__body">
        <div class="mobile-support-panel__success" role="status">
          Your message was sent. Our support team will reply by email.
        </div>

        <div class="mobile-support-panel__error" role="alert">
          The message could not be sent. Please try again.
        </div>

        <div class="mobile-support-panel__message">
          <strong>Hi, how can we help?</strong>
          <span>Send your question below and our support team will respond by email.</span>
        </div>

        <form class="mobile-support-panel__form" method="post" action="/contact#contact_form" accept-charset="UTF-8" data-mobile-support-form>
          <input type="hidden" name="form_type" value="contact">
          <input type="hidden" name="utf8" value="✓">

          <label class="mobile-support-panel__field">
            <span>Name</span>
            <input type="text" name="contact[name]" autocomplete="name" placeholder="Your name">
          </label>

          <label class="mobile-support-panel__field">
            <span>Email</span>
            <input type="email" name="contact[email]" autocomplete="email" inputmode="email" placeholder="you@example.com" required>
          </label>

          <label class="mobile-support-panel__field">
            <span>Order number <small>(optional)</small></span>
            <input type="text" name="contact[Order number]" autocomplete="off" placeholder="Order number">
          </label>

          <label class="mobile-support-panel__field">
            <span>Message</span>
            <textarea name="contact[body]" placeholder="How can we help?" required></textarea>
          </label>

          <button type="submit" class="mobile-support-panel__submit">Send message</button>

          <div class="mobile-support-panel__divider">or</div>

          <a class="mobile-support-panel__track" href="/pages/track-order">Track my order</a>
        </form>
      </div>
    `;

    document.body.append(backdrop, panel);

    backdrop.addEventListener('click', closeSupport);
    panel.querySelector('[data-mobile-support-close]')?.addEventListener('click', closeSupport);
    panel.querySelector('[data-mobile-support-form]')?.addEventListener('submit', submitSupportForm);

    return panel;
  };

  const openSupport = () => {
    const panel = createSupportPanel();
    const backdrop = getSupportBackdrop();
    if (!panel || !backdrop) return false;

    updateNavHeight();
    panel.classList.remove('is-success', 'is-error');
    backdrop.hidden = false;

    window.requestAnimationFrame(() => {
      panel.setAttribute('aria-hidden', 'false');
      panel.querySelector('input, textarea, button')?.focus({ preventScroll: true });
    });

    activePanel = 'chat';
    setActiveButton('chat');
    return true;
  };

  const closeSupport = () => {
    const panel = getSupportPanel();
    const backdrop = getSupportBackdrop();
    if (!panel) return false;

    panel.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.hidden = true;

    if (activePanel === 'chat') {
      activePanel = null;
      setActiveButton(null);
    }

    return true;
  };

  const toggleSupport = () => {
    if (supportIsOpen()) return closeSupport();
    return openSupport();
  };

  const submitSupportForm = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    const panel = getSupportPanel();
    const submit = form.querySelector('[type="submit"]');
    if (!panel || !submit) return;

    panel.classList.remove('is-success', 'is-error');
    submit.disabled = true;
    submit.textContent = 'Sending…';

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      form.reset();
      panel.classList.add('is-success');
      panel.querySelector('.mobile-support-panel__body')?.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error('Mobile support form submission failed:', error);
      panel.classList.add('is-error');
      panel.querySelector('.mobile-support-panel__body')?.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      submit.disabled = false;
      submit.textContent = 'Send message';
    }
  };

  const openRewards = () => {
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') { window.SmileUI.openPanel(); return true; }
    const launcher = findSmileLauncher();
    if (!launcher) return false;
    launcher.click();
    return true;
  };

  const closeRewards = () => {
    if (window.SmileUI && typeof window.SmileUI.closePanel === 'function') { window.SmileUI.closePanel(); return true; }
    const launcher = findSmileLauncher();
    if (!launcher) return false;
    launcher.click();
    return true;
  };

  const prepareRewards = () => {
    const launcher = findSmileLauncher();
    if (!launcher) return;
    launcher.style.setProperty('opacity', '0', 'important');
    launcher.style.setProperty('visibility', 'hidden', 'important');
    launcher.style.setProperty('pointer-events', 'none', 'important');
  };

  const sizeRewards = () => {
    const nav = getNav();
    const container = document.querySelector('#smile-ui-container');
    if (!MOBILE_QUERY.matches || !nav || !container) return;
    updateNavHeight();
    const navHeight = Math.ceil(nav.getBoundingClientRect().height || 64);
    const styles = window.getComputedStyle(nav);
    const width = parseInt(styles.getPropertyValue('--mobile-bottom-nav-panel-width'), 10) || 400;
    const height = parseInt(styles.getPropertyValue('--mobile-bottom-nav-rewards-height'), 10) || 600;
    const panel = Array.from(container.querySelectorAll('*')).filter((element) => {
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.position === 'fixed' && rect.width > 300 && rect.height > 350;
    }).sort((a, b) => {
      const ar = a.getBoundingClientRect();
      const br = b.getBoundingClientRect();
      return (br.width * br.height) - (ar.width * ar.height);
    })[0];
    if (!panel) return;
    panel.style.setProperty('inset', `auto 10px ${navHeight + 8}px auto`, 'important');
    panel.style.setProperty('width', `min(${width}px, calc(100vw - 20px))`, 'important');
    panel.style.setProperty('max-width', `min(${width}px, calc(100vw - 20px))`, 'important');
    panel.style.setProperty('height', `min(${height}px, calc(100dvh - ${navHeight + 20}px))`, 'important');
    panel.style.setProperty('max-height', `min(${height}px, calc(100dvh - ${navHeight + 20}px))`, 'important');
    panel.style.setProperty('border-radius', '16px', 'important');
    panel.style.setProperty('overflow', 'hidden', 'important');
  };

  const pressHeaderMenuButton = () => { const button = getHeaderMenuButton(); if (!button) return false; button.click(); return true; };
  const closeMenu = () => { if (menuIsOpen()) pressHeaderMenuButton(); };

  const closeOtherPanels = async (except) => {
    if (except !== 'chat' && supportIsOpen()) closeSupport();
    if (except !== 'rewards' && activePanel === 'rewards') closeRewards();
    if (except !== 'menu' && menuIsOpen()) closeMenu();
  };

  const toggleAppPanel = async (action) => {
    if (action === 'chat') {
      if (supportIsOpen()) {
        closeSupport();
        return;
      }

      await closeOtherPanels('chat');
      openSupport();
      return;
    }
    if (action === 'rewards') {
      if (activePanel === 'rewards') {
        closeRewards(); activePanel = null; setActiveButton(null); return;
      }
      await closeOtherPanels('rewards');
      if (openRewards()) {
        activePanel = 'rewards'; setActiveButton('rewards');
        window.setTimeout(sizeRewards, 100); window.setTimeout(sizeRewards, 500);
      }
    }
  };

const toggleMenu = async () => {
  if (menuIsOpen()) {
    closeMenu();
    activePanel = null;
    setActiveButton(null);
    document.documentElement.classList.remove('mobile-menu-is-open');
    return;
  }

  await closeOtherPanels('menu');

  window.requestAnimationFrame(() => {
    if (pressHeaderMenuButton()) {
      activePanel = 'menu';
      setActiveButton('menu');
      document.documentElement.classList.add('mobile-menu-is-open');

      const menu = getMobileMenu();

      if (menu) {
        menu.scrollTop = 0;

        const scrollArea = menu.querySelector(
          '.drawer__inner, .mobile-menu__inner, .drawer__content'
        );

        if (scrollArea) {
          scrollArea.scrollTop = 0;
        }
      }
    }
  });
};

  const bindButtons = () => {
    document.querySelectorAll('[data-mobile-app-action]').forEach((button) => {
      if (button.dataset.mobileBottomNavBound === 'true') return;
      button.dataset.mobileBottomNavBound = 'true';
      button.addEventListener('click', () => toggleAppPanel(button.dataset.mobileAppAction));
    });
    getMenuButtons().forEach((button) => {
      if (button.dataset.mobileBottomNavBound === 'true') return;
      button.dataset.mobileBottomNavBound = 'true';
      button.addEventListener('click', toggleMenu);
    });
  };


  const refresh = () => {
    if (!MOBILE_QUERY.matches || !getNav()) return;
    updateNavHeight();
    bindButtons();
    prepareRewards();
    createSupportPanel();
    sizeRewards();
  };

  const init = () => {
    refresh();
    [300, 800, 1600, 3000].forEach((delay) => window.setTimeout(refresh, delay));
    window.addEventListener('resize', refresh, { passive: true });
    document.addEventListener('shopify:section:load', refresh);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();